import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import i18init from './translations/i18init';

import AppErrorBoundary from './components/Smart/ErrorBoundaries/AppErrorBoundary/AppErrorBoundary';

// INIT i18next
i18init();

// create react app
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);
root.render(
	<Provider store={store}>
		<AppErrorBoundary>
			<App />
		</AppErrorBoundary>
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
